/**
 * Bundles Landing Page JavaScript
 * Handles bundle selection, subscription toggle, FAQ accordion, and add to cart
 * 
 * Upload to: assets/bundles-landing.js
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initHeroCarousels();
    initHeroCarouselSelect();
    initStickyAtcDrawer();
    initProductDetailModal();
    initBundleSelector();
    initSubscriptionToggle();
    initStickyFrequencySelect();
    initFAQAccordion();
    initAddToCart();
    initSmoothScroll();
    initAnalytics();
  }

  /**
   * Product detail modal — "View full details" opens popup with full description
   */
  function initProductDetailModal() {
    var modal = document.getElementById('product-detail-modal');
    if (!modal) return;

    var titleEl = modal.querySelector('.product-detail-modal-title');
    var bodyEl = modal.querySelector('.product-detail-modal-body');
    var closeButtons = modal.querySelectorAll('[data-product-detail-close]');

    function openModal(title, descriptionHtml) {
      if (titleEl) titleEl.textContent = title;
      if (bodyEl) bodyEl.innerHTML = descriptionHtml || '<p>No description available.</p>';
      modal.removeAttribute('hidden');
      modal.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      modal.removeAttribute('data-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-product-detail-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var row = this.closest('.inside-row');
        if (!row) return;
        var titleEl = row.querySelector('.inside-row-title');
        var descEl = row.querySelector('.inside-product-full-description');
        var title = titleEl ? titleEl.textContent.trim() : 'Product details';
        var html = descEl ? descEl.innerHTML.trim() : '';
        openModal(title, html);
      });
    });

    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') closeModal();
    });
  }

  /**
   * Hero bundle carousel (Embla) — one carousel, slides = bundles
   */
  function initHeroCarousels() {
    if (typeof window.EmblaCarousel === 'undefined') return;

    var wrapper = document.querySelector('[data-hero-carousel]');
    if (!wrapper) return;

    var viewport = wrapper.querySelector('.embla__viewport');
    var prevBtn = wrapper.querySelector('.embla__prev');
    var nextBtn = wrapper.querySelector('.embla__next');
    var dotsEl = wrapper.querySelector('[data-dots]');
    if (!viewport) return;

    var emblaApi = window.EmblaCarousel(viewport, {
      loop: true,
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (emblaApi.scrollToPrev) emblaApi.scrollToPrev();
        else if (emblaApi.scrollPrev) emblaApi.scrollPrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (emblaApi.scrollToNext) emblaApi.scrollToNext();
        else if (emblaApi.scrollNext) emblaApi.scrollNext();
      });
    }

    var slides = viewport.querySelectorAll('.embla__slide');
    var dotCount = slides.length;
    if (dotsEl && dotCount > 1) {
      dotsEl.innerHTML = '';
      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'embla__dot' + (i === 0 ? ' is-selected' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', (function(idx) {
          return function() { emblaApi.scrollTo(idx); };
        })(i));
        dotsEl.appendChild(dot);
      }
      emblaApi.on('select', function() {
        var idx = emblaApi.selectedScrollSnap();
        dotsEl.querySelectorAll('.embla__dot').forEach(function(d, i) {
          d.classList.toggle('is-selected', i === idx);
        });
      });
    }
  }

  /**
   * Click on hero carousel bundle slide → select that bundle (same as offer section)
   */
  function initHeroCarouselSelect() {
    document.querySelectorAll('[data-hero-carousel-select]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var bundleId = this.dataset.bundleId;
        if (!bundleId) return;
        var bundleOption = document.querySelector('.bundle-option[data-bundle-id="' + bundleId + '"]');
        if (!bundleOption) return;
        var radio = bundleOption.querySelector('input[type="radio"]');
        if (!radio || radio.checked) return;

        radio.checked = true;
        var bundlePrice = parseFloat(bundleOption.dataset.bundlePrice);
        var bundleCompare = parseFloat(bundleOption.dataset.bundleCompare);
        var hasSubscription = bundleOption.dataset.hasSubscription === 'true' || bundleOption.dataset.hasSubscription === '1';

        updatePricing(bundlePrice, bundleCompare);
        updateSubscribeVisibility(hasSubscription, bundlePrice);
        updatePackContentsVisibility(bundleId);
        updateFrequencyBlock(bundleId);
        updateStickyAtc(bundleOption);
        updateHeroCarouselSelectedState(bundleId);
        flashContentUpdate();

        trackEvent('bundle_select', { bundle_id: bundleId, price: bundlePrice, source: this.closest('[data-sticky-atc-drawer]') ? 'sticky_drawer' : 'hero_carousel' });

        var isFromDrawer = this.closest('[data-sticky-atc-drawer]');
        if (isFromDrawer) {
          closeStickyAtcDrawer();
        } else {
          var nextSection = document.getElementById('hero');
          if (nextSection) nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    var checked = document.querySelector('.bundle-option input[type="radio"]:checked');
    if (checked && checked.closest('.bundle-option').dataset.bundleId) {
      updateHeroCarouselSelectedState(checked.closest('.bundle-option').dataset.bundleId);
    }
  }

  /**
   * Sticky ATC drawer — mobile: handle to expand/collapse, shows bundle list
   */
  function initStickyAtcDrawer() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var handle = document.querySelector('[data-sticky-atc-handle]');
    if (!sticky || !handle) return;

    handle.addEventListener('click', function() {
      var expanded = sticky.classList.toggle('is-expanded');
      handle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      handle.setAttribute('aria-label', expanded ? 'Collapse' : 'Expand to change bundle');
    });
  }

  function closeStickyAtcDrawer() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var handle = document.querySelector('[data-sticky-atc-handle]');
    if (sticky) sticky.classList.remove('is-expanded');
    if (handle) {
      handle.setAttribute('aria-expanded', 'false');
      handle.setAttribute('aria-label', 'Expand to change bundle');
    }
  }

  /**
   * Mark the hero carousel slide that matches the selected bundle
   */
  function updateHeroCarouselSelectedState(bundleId) {
    var id = String(bundleId);
    document.querySelectorAll('[data-hero-carousel-select]').forEach(function(btn) {
      btn.classList.toggle('is-selected', btn.dataset.bundleId === id);
    });
  }

  function initStickyFrequencySelect() {
    document.querySelectorAll('[data-sticky-frequency]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var bundleId = this.dataset.bundleId;
        var planId = this.value;
        var radio = document.querySelector('[data-frequency-block][data-bundle-id="' + bundleId + '"] input[data-selling-plan-id="' + planId + '"]');
        if (radio) radio.checked = true;
      });
    });
    var freqContainer = document.querySelector('[data-frequency-container]');
    if (freqContainer) {
      freqContainer.addEventListener('change', function(e) {
        var radio = e.target && e.target.type === 'radio' && e.target.dataset.sellingPlanId ? e.target : null;
        if (!radio) return;
        var block = radio.closest('[data-frequency-block]');
        var bundleId = block && block.dataset.bundleId;
        if (!bundleId) return;
        var stickySelect = document.querySelector('[data-sticky-frequency][data-bundle-id="' + bundleId + '"]');
        if (stickySelect && stickySelect.value !== radio.value) stickySelect.value = radio.value;
      });
    }
  }

  /**
   * Bundle Selector
   * Updates price and subscribe UI when switching bundle options
   */
  function initBundleSelector() {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;

    const bundleOptions = bundleSelector.querySelectorAll('.bundle-option input[type="radio"]');

    bundleOptions.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          const bundleOption = this.closest('.bundle-option');
          const bundleId = bundleOption.dataset.bundleId;
          const bundlePrice = parseFloat(bundleOption.dataset.bundlePrice);
          const bundleCompare = parseFloat(bundleOption.dataset.bundleCompare);
          const hasSubscription = bundleOption.dataset.hasSubscription === 'true' || bundleOption.dataset.hasSubscription === '1';

          updatePricing(bundlePrice, bundleCompare);
          updateSubscribeVisibility(hasSubscription, bundlePrice);
          updatePackContentsVisibility(bundleId);
          updateFrequencyBlock(bundleId);
          updateStickyAtc(bundleOption);
          
          // Visual feedback: highlight what changed
          flashContentUpdate();

          trackEvent('bundle_select', {
            bundle_id: bundleId,
            price: bundlePrice
          });
        }
      });
    });

    // Initial state: subscribe UI, pack contents, frequency, sticky for first selected product
    var checked = bundleSelector.querySelector('.bundle-option input[type="radio"]:checked');
    if (checked) {
      var opt = checked.closest('.bundle-option');
      var hasSub = opt && (opt.dataset.hasSubscription === 'true' || opt.dataset.hasSubscription === '1');
      updateSubscribeVisibility(!!hasSub, parseFloat(opt.dataset.bundlePrice));
      if (opt && opt.dataset.bundleId) {
        updatePackContentsVisibility(opt.dataset.bundleId);
        updateFrequencyBlock(opt.dataset.bundleId);
        updateStickyAtc(opt);
      }
    }
  }
  
  /**
   * Flash visual feedback when content updates (bundle change)
   */
  function flashContentUpdate() {
    // Flash hero visual card
    var heroVisual = document.querySelector('.hero-visual .visual-card');
    if (heroVisual) {
      heroVisual.style.transition = 'all 0.3s ease';
      heroVisual.style.transform = 'scale(0.98)';
      heroVisual.style.opacity = '0.7';
      setTimeout(function() {
        heroVisual.style.transform = 'scale(1)';
        heroVisual.style.opacity = '1';
      }, 150);
    }
    
    // Flash inside section if visible
    var insideSection = document.querySelector('.bundles-inside-priority');
    if (insideSection && isElementInViewport(insideSection)) {
      var cards = insideSection.querySelectorAll('.inside-product-card');
      cards.forEach(function(card, idx) {
        setTimeout(function() {
          card.style.transition = 'all 0.3s ease';
          card.style.transform = 'scale(0.97)';
          card.style.opacity = '0.6';
          setTimeout(function() {
            card.style.transform = 'scale(1)';
            card.style.opacity = '1';
          }, 150);
        }, idx * 50);
      });
    }
  }
  
  /**
   * Check if element is in viewport
   */
  function isElementInViewport(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  /**
   * Show the Pack contents and What's inside blocks for the selected bundle; hide the rest
   */
  function updatePackContentsVisibility(bundleId) {
    const id = String(bundleId);
    
    // Update all pack content blocks
    document.querySelectorAll('.pack-contents-block').forEach(function(block) {
      const isVisible = block.dataset.bundleId === id;
      block.style.display = isVisible ? '' : 'none';
      
      // Animate if becoming visible
      if (isVisible) {
        block.style.opacity = '0';
        setTimeout(function() {
          block.style.transition = 'opacity 0.4s ease';
          block.style.opacity = '1';
        }, 50);
        
        // Update product count
        updateProductCount(block);
      }
    });
    
    document.querySelectorAll('.inside-contents-block').forEach(function(block) {
      const isVisible = block.dataset.bundleId === id;
      block.style.display = isVisible ? '' : 'none';
    });
    document.querySelectorAll('.offer-pack-contents-block').forEach(function(block) {
      const offerVisible = block.dataset.bundleId === id;
      block.style.display = offerVisible ? '' : 'none';
      if (offerVisible) {
        block.style.opacity = '0';
        setTimeout(function() {
          block.style.transition = 'opacity 0.4s ease';
          block.style.opacity = '1';
        }, 50);
      }
    });

    updateHeroCarouselSelectedState(id);

    document.querySelectorAll('.hero-bundle-image-block').forEach(function(block) {
      const isVisible = block.dataset.bundleId === id;
      block.style.display = isVisible ? '' : 'none';
      
      // Animate if becoming visible
      if (isVisible) {
        block.style.opacity = '0';
        setTimeout(function() {
          block.style.transition = 'opacity 0.3s ease';
          block.style.opacity = '1';
        }, 50);
      }
    });
  }
  
  /**
   * Update product count in visual header
   */
  function updateProductCount(block) {
    var countEl = document.querySelector('[data-product-count]');
    if (!countEl || !block) return;
    
    var items = block.querySelectorAll('.product-preview-item');
    var count = items.length;
    
    var numberEl = countEl.querySelector('.count-number');
    if (numberEl && count > 0) {
      numberEl.style.transition = 'transform 0.3s ease';
      numberEl.style.transform = 'scale(1.2)';
      setTimeout(function() {
        numberEl.textContent = count;
        numberEl.style.transform = 'scale(1)';
      }, 150);
    }
  }

  function updateFrequencyBlock(bundleId) {
    var id = String(bundleId);
    document.querySelectorAll('[data-frequency-block]').forEach(function(block) {
      block.style.display = block.dataset.bundleId === id ? '' : 'none';
    });
    var firstRadio = document.querySelector('[data-frequency-block][data-bundle-id="' + id + '"] input[type="radio"]');
    if (firstRadio) firstRadio.checked = true;
    updateStickyFrequencySelect(id);
  }

  function updateStickyFrequencySelect(bundleId) {
    var id = String(bundleId);
    var selects = document.querySelectorAll('[data-sticky-frequency]');
    selects.forEach(function(sel) {
      sel.style.display = sel.dataset.bundleId === id ? '' : 'none';
    });
    var visibleSelect = document.querySelector('[data-sticky-frequency][data-bundle-id="' + id + '"]');
    if (visibleSelect && visibleSelect.options.length) {
      visibleSelect.selectedIndex = 0;
    }
  }

  function updateStickyAtc(bundleOption) {
    var thumb = document.querySelector('[data-sticky-atc-thumb]');
    var priceEl = document.querySelector('[data-sticky-atc-price]');
    var badgeEl = document.querySelector('[data-sticky-atc-badge]');
    var toggle = document.querySelector('[data-subscription-toggle]');
    if (!bundleOption || !priceEl) return;
    var isSubscribed = toggle && toggle.getAttribute('aria-checked') === 'true';
    var card = document.querySelector('.subscription-toggle-card');
    var useSubscriptionPrice = isSubscribed && card && !card.classList.contains('subscription-disabled');
    var displayPrice = document.querySelector('[data-total-price]');
    var priceText = (displayPrice && useSubscriptionPrice) ? displayPrice.textContent : formatMoney(parseFloat(bundleOption.dataset.bundlePrice));
    if (thumb && bundleOption.dataset.bundleThumb) {
      thumb.src = bundleOption.dataset.bundleThumb;
      thumb.alt = '';
    }
    priceEl.textContent = priceText;
    if (badgeEl) {
      if (card && card.classList.contains('subscription-disabled')) {
        badgeEl.textContent = 'One-time purchase';
      } else {
        badgeEl.textContent = isSubscribed ? ('Subscribe & Save ' + (card && card.dataset.subscribePct ? card.dataset.subscribePct : '20') + '%') : 'One-time purchase';
      }
    }
    var stickyWrap = document.querySelector('[data-sticky-subscribe-wrap]');
    if (stickyWrap) {
      stickyWrap.style.display = (card && card.classList.contains('subscription-disabled')) ? 'none' : '';
    }
  }

  /**
   * Show or hide subscribe block based on whether selected product has selling plans.
   * When product has subscription, default to Subscribe ON so price stays subscription.
   */
  function updateSubscribeVisibility(hasSubscription, oneTimePrice) {
    var card = document.querySelector('.subscription-toggle-card');
    var toggles = document.querySelectorAll('[data-subscription-toggle]');
    var savingsDisplay = document.querySelector('[data-savings-display]');
    var totalPriceEl = document.querySelector('[data-total-price]');
    var stickyWrap = document.querySelector('[data-sticky-subscribe-wrap]');

    if (!card || !totalPriceEl) return;

    if (hasSubscription && toggles.length) {
      card.classList.remove('subscription-disabled');
      card.classList.remove('subscription-one-time');
      toggles.forEach(function(t) {
        t.style.display = '';
        t.setAttribute('aria-disabled', 'false');
        t.setAttribute('aria-checked', 'true'); /* default ON when switching bundle */
      });
      if (savingsDisplay) savingsDisplay.style.display = '';
      if (stickyWrap) stickyWrap.style.display = '';
      updateSubscriptionPricing(oneTimePrice, true);
      updateFrequencyVisibility(true);
    } else {
      card.classList.add('subscription-disabled');
      if (stickyWrap) stickyWrap.style.display = 'none';
      toggles.forEach(function(t) {
        t.style.display = 'none';
        t.setAttribute('aria-checked', 'false');
        t.setAttribute('aria-disabled', 'true');
      });
      if (savingsDisplay) savingsDisplay.style.display = 'none';
      totalPriceEl.textContent = formatMoney(oneTimePrice);
      updateFrequencyVisibility(false);
    }
  }

  function updateFrequencyVisibility(show) {
    var container = document.querySelector('[data-frequency-container]');
    var card = document.querySelector('.subscription-toggle-card');
    var stickyFreqWrap = document.querySelector('[data-sticky-frequency-wrap]');
    if (!card) return;
    if (show && !card.classList.contains('subscription-disabled')) {
      card.classList.remove('subscription-one-time');
      if (container) container.style.display = '';
      if (stickyFreqWrap) stickyFreqWrap.style.display = '';
    } else {
      card.classList.add('subscription-one-time');
      if (container) container.style.display = 'none';
      if (stickyFreqWrap) stickyFreqWrap.style.display = 'none';
    }
  }

  /**
   * Subscription Toggle — main card and sticky bar; keep both in sync
   */
  function initSubscriptionToggle() {
    var toggleButtons = document.querySelectorAll('[data-subscription-toggle]');
    if (!toggleButtons.length) return;

    function setSubscriptionState(newState) {
      var currentPrice = getCurrentBundlePrice();
      toggleButtons.forEach(function(t) {
        t.setAttribute('aria-checked', newState ? 'true' : 'false');
      });
      updateSubscriptionPricing(currentPrice, newState);
      updateFrequencyVisibility(newState);
      var opt = document.querySelector('.bundle-option input[type="radio"]:checked');
      if (opt && opt.closest('.bundle-option')) updateStickyAtc(opt.closest('.bundle-option'));
    }

    toggleButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var isChecked = this.getAttribute('aria-checked') === 'true';
        var newState = !isChecked;
        setSubscriptionState(newState);
        trackEvent('subscription_toggle', { enabled: newState });
      });
    });
  }

  /**
   * Update pricing display
   */
  function updatePricing(price, comparePrice) {
    // Update hero price
    const heroPriceEl = document.querySelector('[data-final-price]');
    if (heroPriceEl) {
      heroPriceEl.textContent = formatMoney(price);
    }

    // Update offer section price
    const totalPriceEl = document.querySelector('[data-total-price]');
    if (totalPriceEl) {
      totalPriceEl.textContent = formatMoney(price);
    }

    // Update mobile sticky price
    const mobilePriceEl = document.querySelector('[data-mobile-price]');
    if (mobilePriceEl) {
      mobilePriceEl.textContent = formatMoney(price);
    }

    // Update subscription savings if toggle is on
    const toggleButton = document.querySelector('[data-subscription-toggle]');
    if (toggleButton && toggleButton.getAttribute('aria-checked') === 'true') {
      updateSubscriptionPricing(price, true);
    }
  }

  /**
   * Update subscription pricing with discount
   */
  function updateSubscriptionPricing(basePrice, isSubscribed) {
    const card = document.querySelector('[data-subscribe-pct]');
    const pct = card ? parseInt(card.dataset.subscribePct, 10) : 20;
    const discountPercent = (pct || 20) / 100;
    const savingsDisplay = document.querySelector('[data-savings-display]');
    const savingsAmount = document.querySelector('[data-savings-amount]');
    const totalPriceEl = document.querySelector('[data-total-price]');

    if (!savingsDisplay || !savingsAmount || !totalPriceEl) return;

    if (isSubscribed) {
      const savings = basePrice * discountPercent;
      const finalPrice = basePrice - savings;
      
      savingsDisplay.style.display = 'block';
      savingsAmount.textContent = formatMoney(savings);
      totalPriceEl.textContent = formatMoney(finalPrice);
    } else {
      savingsDisplay.style.display = 'none';
      totalPriceEl.textContent = formatMoney(basePrice);
    }
  }

  /**
   * Get current selected bundle price
   */
  function getCurrentBundlePrice() {
    const selectedOption = document.querySelector('.bundle-option input[type="radio"]:checked');
    if (selectedOption) {
      const bundleOption = selectedOption.closest('.bundle-option');
      return parseFloat(bundleOption.dataset.bundlePrice);
    }
    return 0;
  }

  /**
   * Update Loop Subscription widget when bundle changes
   */
  function updateLoopSubscription(bundleId) {
    const loopContainer = document.getElementById('loop-subscription-container');
    if (!loopContainer) return;

    // If Loop is installed, trigger a refresh
    // This is a placeholder - actual implementation depends on Loop's API
    const currentProductId = loopContainer.dataset.productId;
    
    if (currentProductId !== bundleId && window.Loop) {
      // Loop API call would go here
      console.log('Update Loop subscription for product:', bundleId);
    }
  }

  /**
   * FAQ Accordion
   * Handles expanding/collapsing FAQ items
   */
  function initFAQAccordion() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const faqItem = this.closest('.faq-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other FAQ items
        document.querySelectorAll('.faq-item').forEach(item => {
          if (item !== faqItem) {
            item.classList.remove('active');
            const btn = item.querySelector('.faq-question');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Toggle current item
        if (isExpanded) {
          faqItem.classList.remove('active');
          this.setAttribute('aria-expanded', 'false');
        } else {
          faqItem.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
        }
        
        // Analytics tracking
        trackEvent('faq_toggle', {
          question: this.textContent.trim(),
          expanded: !isExpanded
        });
      });
    });
  }

  /**
   * Add to Cart — uses variant id and selling_plan from selected frequency (or bundle fallback)
   */
  function initAddToCart() {
    var buttons = document.querySelectorAll('[data-add-to-cart]');
    if (!buttons.length) return;

    function handleAddToCart(e) {
      e.preventDefault();
      var selectedOption = document.querySelector('.bundle-option input[type="radio"]:checked');
      if (!selectedOption) {
        alert('Please select a bundle option');
        return;
      }
      var bundleOption = selectedOption.closest('.bundle-option');
      var variantId = selectedOption.value;
      var bundleId = bundleOption.dataset.bundleId;
      var hasSubscription = bundleOption.dataset.hasSubscription === 'true' || bundleOption.dataset.hasSubscription === '1';
      var toggle = document.querySelector('[data-subscription-toggle]');
      var isSubscribed = hasSubscription && toggle && toggle.getAttribute('aria-checked') === 'true';
      var sellingPlanId = '';
      if (isSubscribed) {
        var stickySelect = document.querySelector('[data-sticky-frequency][data-bundle-id="' + bundleId + '"]');
        if (stickySelect && stickySelect.offsetParent !== null && stickySelect.value) {
          sellingPlanId = stickySelect.value;
        } else {
          var freqBlock = document.querySelector('[data-frequency-block][data-bundle-id="' + bundleId + '"]');
          var freqRadio = freqBlock ? freqBlock.querySelector('input[type="radio"]:checked') : null;
          sellingPlanId = (freqRadio && freqRadio.dataset.sellingPlanId) ? freqRadio.dataset.sellingPlanId : (bundleOption.dataset.sellingPlanId || '');
        }
      }
      addToCart(variantId, sellingPlanId || null);
      trackEvent('add_to_cart', {
        bundle_id: bundleId,
        variant_id: variantId,
        subscription: isSubscribed,
        placement: e.currentTarget.closest('[data-sticky-atc]') ? 'sticky_bar' : 'offer_section'
      });
    }

    buttons.forEach(function(btn) { btn.addEventListener('click', handleAddToCart); });
  }

  /**
   * Add item to Shopify cart
   */
  function addToCart(variantId, sellingPlanId) {
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlanId) item.selling_plan = parseInt(sellingPlanId, 10);
    var formData = { items: [item] };

    var button = document.querySelector('[data-add-to-cart]');
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) throw new Error(data.description || 'Could not add to cart');
        return data;
      });
    })
    .then(function(data) {
      if (button) {
        button.textContent = 'Added!';
        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
      updateCartCount();
      var drawerOpened = false;
      if (window.theme && typeof window.theme.openCart === 'function') {
        window.theme.openCart();
        drawerOpened = true;
      } else if (window.Shopify && window.Shopify.theme && typeof window.Shopify.theme.openCart === 'function') {
        window.Shopify.theme.openCart();
        drawerOpened = true;
      }
      if (!drawerOpened) {
        var cartToggle = document.getElementById('cart-drawer-toggle') || document.querySelector('[data-spark-link="cart"]');
        if (cartToggle) {
          cartToggle.click();
          drawerOpened = true;
        }
      }
      if (!drawerOpened) showCartNotification(data);
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
      alert(error.message || 'There was an error adding the item to your cart. Please try again.');
    });
  }

  /**
   * Update cart count in header
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var countElements = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count, .thb-item-count');
        countElements.forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.classList.add('cart-has-items');
        });
      })
      .catch(function(error) {
        console.error('Error updating cart count:', error);
      });
  }

  /**
   * Show cart notification (fallback if no drawer)
   */
  function showCartNotification(item) {
    var notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.innerHTML = '<div class="cart-notification-content">' +
      '<svg class="cart-notification-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
      '<path d="M16.667 5L7.5 14.167 3.333 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span>Added to cart</span>' +
      '<a href="/cart" class="cart-notification-link">View cart</a>' +
      '</div>';
    document.body.appendChild(notification);
    setTimeout(function() { notification.classList.add('show'); }, 10);
    setTimeout(function() {
      notification.classList.remove('show');
      setTimeout(function() { notification.remove(); }, 300);
    }, 3000);
  }

  /**
   * Smooth scroll for anchor links
   */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        // Skip if it's just "#"
        if (href === '#') {
          e.preventDefault();
          return;
        }
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          
          const offsetTop = target.offsetTop - 80; // Account for sticky header
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /**
   * Analytics initialization
   */
  function initAnalytics() {
    // Track page view
    trackEvent('view_bundles_page', {
      page: 'bundles_landing'
    });

    // Track scroll depth
    let scrollDepth = 0;
    const scrollThresholds = [25, 50, 75, 100];
    
    window.addEventListener('scroll', debounce(function() {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollPercent = Math.round((scrollTop / (documentHeight - windowHeight)) * 100);
      
      scrollThresholds.forEach(threshold => {
        if (scrollPercent >= threshold && scrollDepth < threshold) {
          scrollDepth = threshold;
          trackEvent('scroll_depth', {
            depth: threshold
          });
        }
      });
    }, 500));
  }

  /**
   * Track analytics events
   */
  function trackEvent(eventName, properties = {}) {
    // Meta Pixel
    if (window.fbq) {
      window.fbq('trackCustom', eventName, properties);
    }

    // Google Analytics 4
    if (window.gtag) {
      window.gtag('event', eventName, properties);
    }

    // PostHog
    if (window.posthog) {
      window.posthog.capture(eventName, properties);
    }

    // Segment
    if (window.analytics) {
      window.analytics.track(eventName, properties);
    }

    // Console log for debugging
    console.log('[Analytics]', eventName, properties);
  }

  /**
   * Format money using Shopify's money format
   */
  function formatMoney(cents) {
    // Get Shopify's money format from theme settings
    const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
    
    // Convert cents to dollars
    const amount = (cents / 100).toFixed(2);
    
    // Replace placeholder with amount
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  /**
   * Debounce utility function
   */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * Expose public API
   */
  window.BundlesLanding = {
    updatePricing,
    addToCart,
    trackEvent
  };

})();
